var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "viber",
    clipPath: "url(#clip0_231_22003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624374",
    x: 0.663086,
    width: 62.0001,
    height: 62,
    rx: 24.8,
    fill: "url(#paint0_linear_231_22003)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.1972 21.7873L48.1871 21.7464C47.3588 18.3978 43.6245 14.8047 40.1951 14.0572L40.1565 14.0492C34.6097 12.9911 28.9855 12.9911 23.4398 14.0492L23.4 14.0572C19.9718 14.8047 16.2374 18.398 15.408 21.7464L15.3988 21.7873C14.3749 26.4636 14.3749 31.2061 15.3988 35.8824L15.408 35.9233C16.2022 39.1289 19.6583 42.5571 22.9597 43.4998V47.2377C22.9597 48.5907 24.6084 49.2551 25.5459 48.2788L29.3331 44.3421C30.1546 44.388 30.9765 44.4137 31.7981 44.4137C34.5902 44.4137 37.3836 44.1496 40.1564 43.6207L40.195 43.6127C43.6244 42.8652 47.3587 39.2718 48.187 35.9235L48.1971 35.8825C49.2211 31.2061 49.2211 26.4639 48.1972 21.7873ZM45.2 35.2044C44.647 37.3891 41.8117 40.1049 39.5589 40.6068C36.6096 41.1677 33.6369 41.4073 30.6672 41.3251C30.6081 41.3234 30.5513 41.3464 30.5103 41.3888C30.0887 41.8213 27.7451 44.2275 27.7451 44.2275L24.804 47.2461C24.5889 47.4704 24.2111 47.3177 24.2111 47.0083V40.816C24.2111 40.7137 24.1381 40.6269 24.0376 40.607C24.037 40.6068 24.0365 40.6068 24.0359 40.6066C21.783 40.1048 18.9487 37.3889 18.3947 35.2043C17.4731 30.9774 17.4731 26.6924 18.3947 22.4655C18.9487 20.2808 21.783 17.5649 24.0359 17.0631C29.1867 16.0835 34.4093 16.0835 39.559 17.0631C41.8129 17.5649 44.6471 20.2808 45.2002 22.4655C46.1228 26.6925 46.1228 30.9775 45.2 35.2044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6999 38.0627C36.3536 37.9574 36.0236 37.8869 35.7169 37.7598C32.5405 36.442 29.6173 34.7418 27.3018 32.1357C25.9851 30.6538 24.9544 28.9806 24.0833 27.21C23.6701 26.3704 23.322 25.4979 22.967 24.6308C22.6435 23.8403 23.1201 23.0237 23.6219 22.4279C24.0929 21.8688 24.6989 21.4411 25.3553 21.1257C25.8675 20.8796 26.3727 21.0215 26.7469 21.4556C27.5555 22.3944 28.2986 23.381 28.8999 24.4692C29.2699 25.1385 29.1684 25.9566 28.4979 26.412C28.3349 26.5227 28.1864 26.6527 28.0347 26.7777C27.9015 26.8873 27.7763 26.998 27.685 27.1463C27.5182 27.4177 27.5102 27.738 27.6175 28.0331C28.4442 30.3049 29.8377 32.0717 32.1245 33.0234C32.4905 33.1756 32.8579 33.3527 33.2795 33.3037C33.9855 33.2212 34.2141 32.4467 34.7089 32.0421C35.1924 31.6468 35.8105 31.6416 36.3313 31.9712C36.8524 32.301 37.3574 32.6549 37.8594 33.0127C38.3523 33.3639 38.8428 33.7072 39.2973 34.1076C39.7344 34.4926 39.885 34.9976 39.6388 35.5198C39.1883 36.4766 38.5326 37.2723 37.587 37.7804C37.3199 37.9235 37.001 37.9699 36.6999 38.0627C37.001 37.9699 36.3536 37.9574 36.6999 38.0627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.8064 20.0318C35.961 20.1483 39.3735 22.9055 40.1048 27.013C40.2294 27.7129 40.2737 28.4283 40.3292 29.1388C40.3526 29.4375 40.1833 29.7214 39.8609 29.7253C39.5279 29.7293 39.3781 29.4506 39.3563 29.1521C39.3136 28.5609 39.2839 27.9669 39.2024 27.3809C38.7724 24.2858 36.3045 21.7253 33.2239 21.1759C32.7602 21.0932 32.286 21.0715 31.8163 21.0222C31.5195 20.9911 31.1308 20.9732 31.065 20.6041C31.0099 20.2947 31.271 20.0484 31.5656 20.0325C31.6454 20.0278 31.7259 20.0316 31.8064 20.0318C35.9612 20.1483 31.7259 20.0316 31.8064 20.0318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.1201 28.2168C38.1132 28.2688 38.1097 28.3907 38.0792 28.5055C37.969 28.9225 37.3364 28.9747 37.191 28.5539C37.1477 28.4291 37.1413 28.2869 37.1411 28.1525C37.1396 27.2726 36.9484 26.3935 36.5046 25.6278C36.0484 24.8408 35.3514 24.1795 34.5342 23.7791C34.0398 23.5371 33.5055 23.3866 32.9637 23.2971C32.7269 23.2579 32.4877 23.2343 32.2497 23.2011C31.9614 23.161 31.8074 22.9773 31.8212 22.6932C31.8339 22.4271 32.0285 22.2354 32.3186 22.252C33.272 22.306 34.193 22.5123 35.0408 22.9611C36.7645 23.874 37.7492 25.3148 38.0367 27.2389C38.0496 27.3262 38.0705 27.4124 38.0771 27.4998C38.0933 27.7156 38.1036 27.9318 38.1201 28.2168C38.1132 28.2685 38.1036 27.9318 38.1201 28.2168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.5366 28.1162C35.1891 28.1225 35.003 27.93 34.9671 27.6115C34.9423 27.3894 34.9224 27.1642 34.8694 26.9479C34.765 26.522 34.5387 26.1275 34.1805 25.8666C34.0114 25.7434 33.8197 25.6537 33.6191 25.5956C33.3642 25.5218 33.0992 25.5422 32.845 25.4799C32.5688 25.4122 32.416 25.1884 32.4595 24.9294C32.4989 24.6935 32.7283 24.5095 32.9861 24.5282C34.5969 24.6445 35.7481 25.4772 35.9125 27.3736C35.9242 27.5074 35.9378 27.6487 35.9081 27.7769C35.857 27.9958 35.6947 28.1056 35.5366 28.1162C35.6947 28.1056 35.1889 28.1224 35.5366 28.1162Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.702 38.0639C37.0041 37.9699 36.3545 37.9573 36.702 38.0639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.8222 20.0327C31.8181 20.0327 31.8141 20.0323 31.8099 20.0323C31.8059 20.032 31.8111 20.0323 31.8222 20.0327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.8105 20.0319C31.8141 20.0319 31.8174 20.0323 31.821 20.0323C32.0515 20.0406 35.8016 20.1448 31.8105 20.0319Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M38.1245 28.219C38.1175 28.2715 38.1077 27.9292 38.1245 28.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.5433 28.1171C35.549 28.1167 35.5544 28.1138 35.5598 28.1132C35.5446 28.1132 35.5211 28.1135 35.4971 28.1144C35.5127 28.1148 35.5269 28.1172 35.5433 28.1171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.5417 28.1173C35.526 28.1176 35.5121 28.1152 35.4969 28.1147C35.4212 28.1168 35.343 28.1209 35.5417 28.1173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M35.5571 28.1132C35.5515 28.1138 35.5463 28.1166 35.541 28.117C35.5822 28.1141 35.5786 28.1132 35.5571 28.1132Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_22003",
    x1: 31.6631,
    y1: 0,
    x2: 31.6631,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F3FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B14B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_22003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.0001,
    height: 62,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/viber.75b9fa8044693f6985912493512d091f.svg";
export { ForwardRef as ReactComponent };